module.exports = __webpack_public_path__ + "html/video-banner_73fe5fd387625f5d16dba9802b8fcc1d.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/video-banner.html
// module id = Exe7
// module chunks = 118